import {CSSProperties, FC} from 'react';


export interface IIconSearchProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconSearch: FC<IIconSearchProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M16.627 15.513 20 18.886 18.886 20l-3.373-3.373a7.057 7.057 0 0 1-4.424 1.55A7.091 7.091 0 0 1 4 11.09 7.091 7.091 0 0 1 11.089 4a7.091 7.091 0 0 1 7.088 7.089 7.057 7.057 0 0 1-1.55 4.424Zm-1.58-.585a5.496 5.496 0 0 0 1.555-3.84 5.512 5.512 0 0 0-5.513-5.513 5.511 5.511 0 0 0-5.514 5.514 5.512 5.512 0 0 0 5.514 5.513 5.496 5.496 0 0 0 3.84-1.555l.118-.119Z" clipRule="evenodd" />
        </svg>
    );
};
